<template>
    <v-app>
        <router-view name="router_view_header"></router-view>

        <v-content>
            <v-container>
                <v-row>
                    <v-col cols=12>
                        <ComponentAlertFlash
                        v-bind:prop_alert_show="component_alert_flash_data.prop_alert_show"
                        v-bind:prop_alert_modal="component_alert_flash_data.prop_alert_modal"
                        v-bind:prop_alert_type="component_alert_flash_data.prop_alert_type"
                        v-bind:prop_alert_heading="component_alert_flash_data.prop_alert_heading"
                        v-bind:prop_alert_message="component_alert_flash_data.prop_alert_message"
                        />
                    </v-col>
                </v-row>
                <router-view></router-view>
            </v-container>
        </v-content>
    </v-app>
</template>

<script>
import { mapGetters } from 'vuex'

//########################################
//IMPORTS libs
//########################################

//########################################
//IMPORTS components
//########################################
import ComponentAlertFlash from './components/ComponentAlertFlash'

//########################################
//IMPORTS pages
//########################################

//########################################
//MAIN
//########################################

export default{
    name: 'App',

    props:[
    ],

    components:{
        ComponentAlertFlash,
    },

    data:function()
    {
        return{
        }
    },

    computed:{
        //============================
        //LOCAL COMPUTED
        //============================

        //============================
        //VUEX COMPUTED HELPERS
        //============================
        ...mapGetters(
            {
                component_alert_flash_data: 'component_alert_flash_getstate_all'
            }
        )
    }
}

//call all with signature func_imp.call(this,param_1,param_2)
//############################################
//HELPERS
//############################################

//############################################
//API_REQUESTS
//############################################

//############################################
//DATA_OPPS
//############################################

//############################################
//ACTIONS
//############################################
</script>